<div class="md:px-28 pt-3 bg-white h-full">
    <div class="pb-4 pt-4 md:py-4 md:px-0 ml-6 md:ml-0">
        <button
            class="gap-2 flex items-center px-4 py-2 border border-[#0D6EFD] rounded-md bg-[#1b3777] text-white transition-colors"
            [routerLink]="['/parkifly', site]">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-6 stroke-white">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
            </svg>
            <p class="font-medium text-sm text-white">{{ "PARKIFLY.BACK_BUTTONS.BACK_TO_START" | transloco }}</p>
        </button>
    </div>
    <div class="bg-white">
        <div class="md:rounded-lg md:shadow-[0_2px_8px_0_rgba(0,0,0,0.25)]">
            <div class="px-4 md:px-8 h-20 flex justify-between items-center border-b border-[#DEE2E6]">
                <div class="flex items-center">
                    <div class="bg-[#F4F2F2] p-2 rounded-[30px]">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                            class="w-5 h-5 fill-[#0040DD]">
                            <path
                                d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z" />
                        </svg>
                    </div>
                    <p class="font-monsterrat font-semibold text-base leading-6 ml-3">
                        {{"PARKIFLY.HOME.MANAGE_BOOKING" | transloco}}
                    </p>
                </div>
            </div>
            <div class="pt-8 font-monsterrat font-normal text-sm leading-6 md:px-8">
                <p class="hidden md:block w-1/3">
                    @if(site == 'skavsta') {
                    {{ "PARKIFLY.MANAGE_BOOKING.SKAVSTA.FILL_IN" | transloco }}
                    }
                    @if(site == 'flygets') {
                    {{ "PARKIFLY.MANAGE_BOOKING.FILL_IN" | transloco }}
                    }
                </p>
                <p class="pt-8 hidden md:block w-1/3">
                    @if(site == 'flygets') {
                    {{ "PARKIFLY.MANAGE_BOOKING.MULTIPLE_LASTNAMES" | transloco }}
                    }
                </p>
                <p class="px-4 md:hidden">
                    Fyll i dina bokningsuppgifter från ditt <br class="hidden lg:inline-block">
                    charterbolag, bokningsnummer och ditt <br class="hidden lg:inline-block">
                    efternamn, och logga för att komplettera din <br class="hidden lg:inline-block">
                    bokning.
                </p>
            </div>
            <div class="px-4 w-full md:w-1/2 md:px-8">
                <div class="pt-8">
                    <div class="InputFieldRow grow shrink basis-0 h-20 justify-start items-start flex w-full">
                        <div class="InputWithCornerHintDesktop grow shrink basis-0 flex-col justify-start items-start">
                            <pf-text-input label="Email" [inputFormControl]="this.handleBookingGroup.controls.email"
                                class="w-full"></pf-text-input>
                        </div>
                    </div>
                </div>
                <div class="pt-8">
                    <div class="InputFieldRow grow shrink basis-0 h-20 justify-start items-start flex w-full">
                        <div class="InputWithCornerHintDesktop grow shrink basis-0 flex-col justify-start items-start">
                            <pf-text-input [label]="'PARKIFLY.MANAGE_BOOKING.ORDER_NUMBER' | transloco"
                                [inputFormControl]="this.handleBookingGroup.controls.bookingNumber"
                                class="w-full"></pf-text-input>
                        </div>
                    </div>
                </div>
                <div class="py-2 md:py-8">
                    <button
                        [ngClass]="{'disabled bg-[#FFE871] text-[#4B4A4A] cursor-default' : !this.handleBookingGroup.controls.email.value || !this.handleBookingGroup.controls.bookingNumber.value,
                            'bg-[#FFC700] hover:bg-[#FFD833]' : this.handleBookingGroup.controls.email.value && this.handleBookingGroup.controls.bookingNumber.value}"
                        class="w-full px-8 py-3 rounded-[4px] font-monsterrat font-semibold text-sm leading-6 flex justify-center md:w-auto"
                        (click)="goToHandleBookingForm()">
                        @if(site == 'skavsta') {
                        {{ "PARKIFLY.MANAGE_BOOKING.SKAVSTA.LOGIN" | transloco }}

                        }
                        @if(site == 'flygets') {
                        {{ "PARKIFLY.MANAGE_BOOKING.SEARCH" | transloco }}

                        }
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                            stroke="currentColor" class="w-6 h-6 ml-2">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3" />
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>